import { Suspense, useEffect, useState } from 'react';
import { Canvas } from '@react-three/fiber';
import { useGLTF } from '@react-three/drei';

import { LightAndShadow } from './SceneComponents/LigthAndShadow.jsx';
import { CityEnvironment, Seasons, Fountains } from './SceneComponents/CityEnvironment.jsx';
import { CustomControls } from './SceneComponents/CustomControls.jsx';
import { LocationSkyboxVideo } from './SceneComponents/LocationSkybox.jsx';
import { DEFAULT_SCENE_MEDIA, VIEW_MODE } from './SceneComponents/VideoConfig.jsx';

import { LocationNames, Locations } from './SceneComponents/Location.jsx';
import { UI } from './LayoutComponents/UI.jsx';
import { getHourNormalized } from './LayoutComponents/DaytimePlayer.jsx';
import { useControls } from 'leva';
import { DEFAULT_SKYBOX_AUDIO_SRC, SkyboxAudioPlayer } from './SceneComponents/SkyboxAudioPlayer.jsx';
import DialogBox from './LayoutComponents/Dialogbox.jsx';

export function Scene({ gyroSettings, location, setLocation, setPureVideo, initialSceneMedia, onReturnHome}) {
	// Load location position
	const locationData = Locations[location];
	const environmentModel = useGLTF(locationData.environmentModel);

	// States
	const [camPosition, setCamPosition] = useState();
	const setLocationAnchorOffset = (offset) => setCamPosition(offset);
	const [camSpeed, setCamSpeed] = useState(0.125);
	const [season, setSeason] = useState(Seasons.SPRING);
	const [fountain, setFountain] = useState(Fountains.CLASSICAL);
	const [hourNormalized, setHourNormalized] = useState(getHourNormalized(10));
	const [autoplay, setAutoplay] = useState(false);
	const toggleAutoplay = () => setAutoplay(!autoplay);
	const [needsReset, setNeedsReset] = useState(true);
	const [inOverview, setInOverview] = useState(false);
	const toggleOverview = () => setInOverview(!inOverview);
	const resetOrientation = () => setNeedsReset(true);
	const [sceneMedia, setSceneMedia] = useState(initialSceneMedia || DEFAULT_SCENE_MEDIA);

	const monthFromSeason = (season) => {
		switch (season) {
			case Seasons.SPRING: return 4 - 1;
			case Seasons.SUMMER: return 7 - 1;
			case Seasons.AUTUMN: return 10 - 1;
			case Seasons.WINTER: return 1 - 1;
			default: return 0;
		}
	}
	const [month, setMonth] = useState(monthFromSeason(season));
	useEffect(() => {
		setMonth(monthFromSeason(season));
	}, [season]);

	const keydownHandler = (event) => {
		switch (event.code) {
			case 'Space': { setCamSpeed((camSpeed > 0) ? 0 : 0.125); } break;
			case 'KeyO': { toggleOverview(); } break;
			case 'KeyP': { toggleAutoplay(); } break;
			case 'KeyA': { setLocation(LocationNames.A); } break;
			case 'KeyB': { setLocation(LocationNames.B); } break;
		}
	};
	const isFlatVideoMode = 
    sceneMedia.viewMode === VIEW_MODE.DRONE || 
    sceneMedia.viewMode === VIEW_MODE.CYCLIST;
	return <>
	{/* 2. Place the audio player outside the Canvas (it's standard HTML, not 3D) */}
	
		<SkyboxAudioPlayer 
                audioSrc={sceneMedia.audioSrc} 
                playAudio={true} 
		/>
		<Canvas
			onKeyDown={keydownHandler}
			shadows
			camera={{ near: 0.1, far: 20000 }}
		>
		<CustomControls
			location={location}
			camHeightOffset={locationData.skyboxHeightOffset} camPosition={camPosition}
			inOverview={inOverview}
			gyroSettings={gyroSettings} lookSpeed={camSpeed}
			needsReset={needsReset} setNeedsReset={setNeedsReset}
			isFlatVideoMode={isFlatVideoMode} 
		/>

		<Suspense fallback={null}>
                <LocationSkyboxVideo 
                    src={sceneMedia.videoSrc} 
                    viewMode={sceneMedia.viewMode} 
                />
		</Suspense>
		</Canvas>

		<UI
                season={season} setSeason={setSeason}
                fountain={fountain} setFountain={setFountain}
                hourNormalized={hourNormalized} setHourNormalized={setHourNormalized}
                autoplayEnabled={autoplay} setAutoplayEnabled={setAutoplay}
                inOverview={inOverview} toggleOverview={toggleOverview}
                resetOrientation={resetOrientation} gyroSettings={gyroSettings}
                sceneMedia={sceneMedia} setSceneMedia={setSceneMedia}    
                onReturnHome={onReturnHome}
                
		/>
	</>
}
